// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";

import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyChYj0cph65QQIdgMJWziqXIvbbnyZdF_M",
    authDomain: "woorie-dae88.firebaseapp.com",
    projectId: "woorie-dae88",
    storageBucket: "woorie-dae88.appspot.com",
    messagingSenderId: "1094477756483",
    appId: "1:1094477756483:web:7a01c44b8093f88dc7fcf6",
    measurementId: "G-0374FE1C3Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export const db = getFirestore(app);
export const auth = getAuth(app);